<template>
  <div class="threeArea">
    <div :style="{ flex: flex[0] }"><slot name="left" ></slot></div>
    <div :style="{ flex: flex[1] }"><slot name="content" ></slot></div>
    <div :style="{ flex: flex[2] }"><slot name="right" ></slot></div>
  </div>
</template>

<script>
  export default {
    name: "ThreeArea",
    props: {
      flex: {
        type: Array,
        default: [1, 3, 2]
      }
    }
  }
</script>

<style scoped>
  .threeArea {
    display: flex;
  }
</style>